package components

import androidx.compose.runtime.Composable
import frontend.lib.classList
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

enum class ButtonSize {
    xs,
    sm,
    base,
    lg,
    xl
}

enum class ButtonColor(val color: String) {
    Slate("slate"),
    Gray("gray"),
    Zinc("zinc"),
    Neutral("neutral"),
    Stone("stone"),
    Red("red"),
    Orange("orange"),
    Amber("amber"),
    Yellow("yellow"),
    Lime("lime"),
    Green("green"),
    Emerald("emerald"),
    Teal("teal"),
    Cyan("cyan"),
    Sky("sky"),
    Blue("blue"),
    Indigo("indigo"),
    Violet("violet"),
    Purple("purple"),
    Fuchsia("fuchsia"),
    Pink("pink"),
    Rose("rose")
}

private val sizeCSS = mapOf(
    ButtonSize.xs to "px-2.5 py-1.5 text-xs rounded",
    ButtonSize.sm to "px-3 py-2 leading-4 text-sm rounded-md",
    ButtonSize.base to "px-4 py-2 text-sm rounded-md",
    ButtonSize.lg to "px-4 py-2 text-base rounded-md",
    ButtonSize.xl to "px-6 py-3 text-base rounded-md"
)

private fun colorCSS(color: ButtonColor): String {
    // FIXME: Tailwind scans code for classes to include, so we can't build them dynamically
    var scanMeTailwind = listOf(
        "bg-green-600 hover:bg-green-700 focus:ring-green-500",
        "bg-red-600 hover:bg-red-700 focus:ring-red-500",
        "bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-500",
        "bg-indigo-600 hover:bg-indigo-700 focus:ring-indigo-500",
        "bg-neutral-600 hover:bg-neutral-700 focus:ring-neutral-500",
    )

    val c = color.color
    return "bg-$c-600 hover:bg-$c-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-$c-500"
}

class TWButtonAttrsBuilder {
    var color = ButtonColor.Indigo
    var isLoading = false
    var size: ButtonSize = ButtonSize.base
    var defaultClasses = "inline-flex items-center border border-transparent font-medium shadow-sm text-white"
    var onClick: () -> Unit = {}

    fun color(bColor: ButtonColor) { color = bColor }
    fun isLoading(state: Boolean) { isLoading = state }
    fun size(s: ButtonSize) { size = s }

    fun onClick(handler: () -> Unit) { onClick = handler }

    fun getClassList(): String {
        val sizeClasses = sizeCSS[size].orEmpty()
        val colorClasses = colorCSS(color)

        return "$defaultClasses $sizeClasses $colorClasses"
    }
}

typealias TWButtonBuilderContext = TWButtonAttrsBuilder.() -> Unit

@Composable
fun TButton(
    attrs: TWButtonBuilderContext = {},
    content: @Composable() () -> Unit
) {
    val builder = TWButtonAttrsBuilder()
    attrs?.invoke(builder)

    Button(attrs = {
        type(ButtonType.Button)
        classList(builder.getClassList())
        onClick { builder.onClick() }
        if (builder.isLoading) disabled()
    }) {
        if (builder.isLoading) {
            Loader()
            Text("Processing...")
        } else content()
    }
}

@Composable
fun TButtonWide(
    attrs: TWButtonBuilderContext = {},
    content: @Composable() () -> Unit
) {

    TButton(attrs = {
        attrs()
        defaultClasses = "w-full flex justify-center border border-transparent font-medium shadow-sm text-white"
    }, content)
}